import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
  directoryChildrenCache: new Map()
};

const mutations = {
  writeDirectoryChildrenToCache(state, { path, object }) {
    const toStore = Object.assign({ cacheTime: Date.now() }, object);
    state.directoryChildrenCache.set(path, toStore);
  }
};

const getters = {
};

const actions = {
  // eslint-disable-next-line no-shadow
  async createCharacterTreeFolder(_, { parent, path }) {
    const parentPath = parent.path === '/' ? '' : parent.path;
    const node = {
      path: `${parentPath}/${path}`
    };

    const resp = await axios.post('/blade/characters/tree/directory', node);
    return resp.data;
  },
  // eslint-disable-next-line no-shadow
  async createCharacterTreeCharacterNode(_, { parent, parentPath, fileName, characterId }) {
    let realParentPath = parentPath || parent.path;
    realParentPath = (realParentPath === '/' ? '' : realParentPath);
    const node = {
      path: `${realParentPath}/${fileName}`,
      characterId
    };

    const resp = await axios.post('/blade/characters/tree/character', node);
    return resp.data;
  },
  async getCharacterTreeChildren({ commit, state }, { path, forceRefresh }) {
    if (!forceRefresh) {
      if (state.directoryChildrenCache.has(path)) {
        const res = Object.assign({}, state.directoryChildrenCache.get(path));

        // Cache only lasts 60 seconds so we pick up other changes
        if (Date.now() - res.cacheTime < 60) {
          delete res.cacheTime;
          return res;
        }
      }
    }

    const response = await axios.post('/blade/characters/tree/list', { path });
    const list = response.data;

    commit('writeDirectoryChildrenToCache', { path, list });

    return list;
  },
  async getCharacterTreeNode(_, { characterTreeNodeId }) {
    const response = await axios.get(`/blade/characters/tree/${characterTreeNodeId}`);
    return response.data;
  },
  async getCharacterTrees() {
    const response = await axios.get('/blade/characters/tree');
    return response.data.characterTrees;
  },
  async getCharacterAliases(_, { _id, characterId }) {
    const cid = _id || characterId;
    const response = await axios.get(`/blade/characters/aliases/${cid}`);
    return response.data.nodes;
  },
  async updateCharacterTreeNode(_, game) {
    const response = await axios.patch(`/blade/characters/tree/${game._id}`, game);
    return response.data.characterTree;
  },
  async deleteCharacterTreeNode(_, { _id, characterTreeNodeId, confirmMultiDelete }) {
    const did = _id || characterTreeNodeId;
    const response = await axios.delete(`/blade/characters/tree/${did}${confirmMultiDelete ? '?confirmMultiDelete=true' : ''}`);
    return response.data.characterTree;
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/character-tree.js